@if (job) {
<div class="job-details-container">
  <mat-card class="mat-elevation-z2 main-card">
    <button
      type="button"
      class="actionBtn"
      [disabled]="disableRefresh"
      (click)="refreshDetails()"
      placement="top auto"
      container="body"
      triggers="hover"
      ngbTooltip="Refresh Details"
    >
      <span class="bi bi-arrow-clockwise"></span>
    </button>
    <mat-card-content class="pt-1 px-2">
      <section class="job-overview">
        <h2>Overview</h2>
        <div class="info-grid-overview">
          <div class="info-item">
            <mat-icon class="bi bi-people-fill">person</mat-icon>
            <div class="info-content">
              <span class="label">User:</span>
              <span class="value">{{ job.user }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="bi bi-stack" style="height: 26px"></mat-icon>
            <div class="info-content">
              <span class="label">Deployment:</span>
              <span class="value">{{ job.deployment }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="bi bi-disc-fill" style="height: 27px"
              >apps</mat-icon
            >
            <div class="info-content">
              <span class="label">Application:</span>
              <span class="value">{{ job.application }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon>new_releases</mat-icon>
            <div class="info-content">
              <span class="label">Version:</span>
              <span class="value">{{ job.version }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="bi bi-cpu-fill">memory</mat-icon>
            <div class="info-content">
              <span class="label">Cores:</span>
              <span class="value">{{ job.maxCores }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon>flag</mat-icon>
            <div class="info-content">
              <span class="label">State:</span>
              <span class="value">{{ job.state }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="bi bi-bar-chart-steps">layers</mat-icon>
            <div class="info-content">
              <span class="label">Stage:</span>
              <span class="value">{{ job.stage }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="bi bi-list-ul">dns</mat-icon>
            <div class="info-content">
              <span class="label">Node List:</span>
              <span class="value">{{ batchNode || "-" }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="bi bi-diagram-3-fill">priority_high</mat-icon>
            <div class="info-content">
              <span class="label">Node Group:</span>
              <span class="value">{{ job.partition }}</span>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="bi bi-arrows-expand" style="height: 27px"
              >priority_high</mat-icon
            >
            <div class="info-content">
              <span class="label">Priority:</span>
              <span class="value">{{ job.priority }}</span>
            </div>
          </div>
        </div>
      </section>

      <mat-divider></mat-divider>

      <section class="additional-information">
        <h2>Additional Information</h2>
        <div class="info-grid-compact">
          <div class="info-item-compact">
            <span class="label">Scheduler Job ID:</span>
            <span class="value">{{ job?.schedulerJobId == -1 ? "NA" : job?.schedulerJobId }}</span>
          </div>
         
          @if (appPropJson.JobGenericProperties?.BeginTime &&
          appPropJson.JobGenericProperties?.BeginTime != "") {
          <div class="info-item-compact">
            <span class="label">Begin Time:</span>
            <span class="value">
              {{
              appPropJson.JobGenericProperties?.BeginTime
              }}
            </span>
          </div>
          }
          
        
          <div class="info-item-compact">
            <span class="label">Allocated Nodes:</span>
            @if(job?.nodelist?.split(',')?.length == 1) {
            <span class="value">{{ job.nodelist }}</span>
            } @else {
            <!-- <ng-select [items]="job.nodelist.split(',')"></ng-select> -->
            <select class="form-select" aria-label="Allocated nodes">
              @for (node of job?.nodelist?.split(","); track $index) {
              <option value="{{ node }}">{{ node }}</option>
              }
            </select>
            }
          </div>
          <div class="info-item-compact">
            <span class="label">HPC Units Used:</span>
            <span class="value">{{ job.unitsUsed }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Auto Scheduled:</span>
            <span class="value">{{ job.autoScheduled }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Stop Allocated:</span>
            <span class="value">{{ job.stopAllocated }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">AutoShut:</span>
            <span class="value">{{ job.autoShut }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Data Backup:</span>
            <span class="value">{{ job.dataBackup }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Output File:</span>
            <span class="value">{{ job.outputFile }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Output Directory:</span>
            <span class="value">{{ job.outputDirectory }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Work Directory:</span>
            <span class="value">{{ job.workDirectory }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Download State</span>
            <span class="value">{{ job.downloadState }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Total Download Size:</span>
            <span class="value">{{ job.totalDownloadSize }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Downloaded Size:</span>
            <span class="value">{{ job.downloadedSize }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Input files:</span>
            @if(inputFileListArray[0].value == '') {
            <span class="value">-</span>
            } @else {
            <!-- <ng-select [items]="job.nodelist.split(',')"></ng-select> -->
            <ng-select #selectElement
                       [searchable]="false"
                       [items]="inputFileListArray"
                       bindLabel="value"
                       bindValue="value"
                       [(ngModel)]="selectedInputFile"
                       [clearable]="false"
                       class="inputFileDisplay"
                       aria-label="Input files"
                       id="fileInputSelect">
              <!-- this show the selected option -->
              <ng-template ng-label-tmp let-item="item">
                <span>{{ getShortContent(item.value, selectElement) }}</span>
              </ng-template>

              <!-- this is to view options -->
              <ng-template ng-option-tmp let-item="item">
                <span>{{ item.value }}</span>
              </ng-template>
              <!-- @for (inp of job.inputFileList.split(","); track $index) {
      <option value="{{ inp }}">{{ inp }}</option>
      } -->
            </ng-select>
            }
          </div>
          <div class="info-item-compact">
            <span class="label">Memory Per CPU:</span>
            <span class="value">
              {{
              appPropJson?.JobGenericProperties?.MemoryPerCpu || "NA"
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Wall clock time:</span>
            <span class="value">
              {{
              appPropJson?.JobGenericProperties?.WallclockTime || "NA"
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Job MPI:</span>
            <span class="value">
              {{
              appPropJson?.JobGenericProperties?.JobMpi || "NA"
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Tasks per node:</span>
            <span class="value">
              {{
              appPropJson?.JobGenericProperties?.TasksPerNode || "NA"
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Is job exclusive ?:</span>
            <span class="value">
              {{
              appPropJson?.JobGenericProperties?.ExclusiveJob == 0
                ? true
                : false
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Minimum scratch space:</span>
            <span class="value">
              {{
              appPropJson?.JobGenericProperties?.MinScratchSpace || "NA"
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Job Dependency:</span>
            <span class="value">
              {{
              appPropJson?.JobGenericProperties?.JobDependency || "NA"
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Job Template:</span>
            <span class="value">{{ job?.jobTemplate || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Localstore Used :</span>
            <span class="value">{{ job?.isLocalStore }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Job Cancel Request:</span>
            <span class="value">{{ job?.jobCancelRequest || "NA" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Job Handler:</span>
            <span class="value">{{ job?.jobHandler }}</span>
          </div>
          <div *ngIf="showPodLink" class="info-item-compact">
            <span (click)="redirectToPod()" class="label">Pod Link:</span>
            <span (click)="redirectToPod()" class="value">{{ job?.name }}</span>
          </div>
          <div *ngIf="showPodLink" class="info-item-compact">
            <span (click)="redirectToPod()" class="label">Environment Used:</span>
            <span (click)="redirectToPod()" class="value">{{ appPropJson.AIMLProperties?.ProcessDataImage }}</span>
          </div>
          <div *ngIf="showPodLink" class="info-item-compact">
            <span (click)="redirectToPod()" class="label">Back Off Limit:</span>
            <span (click)="redirectToPod()" class="value">{{ appPropJson.AIMLProperties?.BackOffLimit }}</span>
          </div>
          <div *ngIf="showPodLink" class="info-item-compact">
            <span (click)="redirectToPod()" class="label">Completions:</span>
            <span (click)="redirectToPod()" class="value">{{ appPropJson.AIMLProperties?.Completions }}</span>
          </div>
        </div>
        <div class="info-item-compact">
          <span class="label">Custom Tags:</span>
          <mat-chip-list>
            <span>
              <input
                class="txtField"
                type="text"
                (keyup.enter)="addtoCustomTags($event)"
                placeholder="Add Custom Tag"
              />
            </span>
            <mat-chip
              *ngFor="let tag of customTags"
              (removed)="removeCustomTag(tag)"
            >
              {{ tag }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <div class="info-item-compact">
          <span class="label">Job Tags:</span>
          <mat-chip-list>
            <span>
              <input
                class="txtField"
                type="text"
                (keyup.enter)="addtoTest($event)"
                placeholder="Add Tag"
              />
            </span>
            <mat-chip *ngFor="let tag of test" (removed)="removeTag(tag)">
              {{ tag }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
      </section>
      <mat-divider></mat-divider>
      <section class="detailed-time-information">
        <h2>Detailed Time Information</h2>
        <div class="info-grid-compact">
          <!-- First Row -->
          <div class="info-item-compact">
            <span class="label">Job Create Time:</span>
            <span class="value">{{ job.startTime | date : "medium" }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Job End Time:</span>
            <span class="value">
              {{ job.endTime == "NA" ? "NA" : (job.endTime | date : "medium") }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Total Time:</span>
            <span class="value">{{ job.totalTime }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Run Time:</span>
            <span class="value">{{ job.runTime }}</span>
          </div>

          <!-- Second Row -->
          <div class="info-item-compact">
            <span class="label">Job Init Entry Time:</span>
            <span class="value">
              {{
          job?.jobInitEntryTime == "NA"
            ? job?.jobInitEntryTime
            : (job?.jobInitEntryTime | date : "medium")
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Data Copy Entry Time:</span>
            <span class="value">
              {{
          job?.jobDataCopyEntryTime == "NA"
            ? job?.jobDataCopyEntryTime
            : (job?.jobDataCopyEntryTime | date : "medium")
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Job Submit Entry Time:</span>
            <span class="value">
              {{
          job?.jobSubmitEntryTime == "NA"
            ? job?.jobSubmitEntryTime
            : (job?.jobSubmitEntryTime | date : "medium")
              }}
            </span>
          </div>
          <div class="info-item-compact">
            <span class="label">Job Execute Entry Time:</span>
            <span class="value">
              {{
          job?.executionStartTime == "NA"
            ? job?.executionStartTime
            : (job?.executionStartTime | date : "medium")
              }}
            </span>
          </div>
        </div>
      </section>
      <mat-divider></mat-divider>

      <section class="other-information">
        <h2>Other Information</h2>
        <div class="info-grid-compact">
          <div class="info-item-compact">
            <span class="label">Description:</span>
            <span class="value">{{ job.description }}</span>
          </div>
          <div class="info-item-compact">
            <span class="label">Remark:</span>
            <span class="value">{{ job.remark }}</span>
          </div>
        </div>
      </section>

      <mat-divider></mat-divider>
    </mat-card-content>
  </mat-card>
</div>
} @else {
<div class="h-100 w-100">
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="jobDetails"
  >
  </ngx-spinner>
</div>
}
